import {
  IonButton,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from '@ionic/react';

import { Link, useLocation } from 'react-router-dom';
import { archiveOutline, archiveSharp, bookmarkOutline, heartOutline, heartSharp, mailOutline, mailSharp, paperPlaneOutline, paperPlaneSharp, trashOutline, trashSharp, warningOutline, warningSharp, documentText, documentTextOutline, chatbubbles, chatbubblesOutline, pulse, pulseOutline, person, personOutline, bookOutline, settings, settingsOutline, cloudUpload, library, wallet, walletOutline, bugOutline, bug } from 'ionicons/icons';
import './Menu.css';

import * as Sentry from "@sentry/react";

import OnboardingHandlers from '@/OnboardingHandlers'

interface AppPage {
  url: string;
  iosIcon: string;
  mdIcon: string;
  title: string;
}

const appPages: AppPage[] = [
  {
    title: 'Documents',
    url: '/docs',
    iosIcon: library,
    mdIcon: library
  },
  // {
  //   title: 'Billing',
  //   url: '/billing',
  //   iosIcon: walletOutline,
  //   mdIcon: wallet
  // },
  // {
  //   title: 'Lessons',
  //   url: '/lessons',
  //   iosIcon: chatbubblesOutline,
  //   mdIcon: chatbubbles
  // },
  // {
  //   title: 'Quizes',
  //   url: '/quizes',
  //   iosIcon: documentTextOutline,
  //   mdIcon: documentText
  // },
  // {
  //   title: 'Feedback',
  //   url: '/feedback',
  //   iosIcon: heartOutline,
  //   mdIcon: heartSharp
  // },
  // {
  //   title: 'Progress',
  //   url: '/progress',
  //   iosIcon: pulseOutline,
  //   mdIcon: pulse
  // },
  // {
  //   title: 'Profile',
  //   url: '/profile',
  //   iosIcon: personOutline,
  //   mdIcon: person
  // },
  // {
  //   title: 'Settings',
  //   url: '/settings',
  //   iosIcon: settingsOutline,
  //   mdIcon: settings
  // }
];

const labels = []; //['Basic Solving', 'Negative Addition', 'Negative Multiplication'];

const mottos = [
  "Just learn it!",
  "Study study study",
  "It's a revolution!",
  "It's an evolution!",
  "Study. Anytime. Anywhere.",
  "Have a great day!",
  "Enjoy your day!",
  "Have a great stay!",
  "Your ad could have been here",
  "Learning made fun",
  "Kindling your flame.",
  "One teacher for every student.",
  "Look for a grain of discovery in the solution.",
  "Victory!",
  "Upload your own textbooks.",
  "Not just test preparation.",
  "There is no cake",
  "Cures social anxiety!"
]

const motto = mottos[Math.floor(mottos.length * Math.random())] 

const Menu: React.FC = () => {
  const location = useLocation();

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonList id="inbox-list">
          <IonListHeader>
            <Link to="/">
              <img className="max-h-13 pt-0 pl-0 p-3" src="/images/convolution-logo.svg" />
            </Link>
          </IonListHeader>
          <IonNote>{motto}</IonNote>
          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem className={location.pathname === appPage.url ? 'selected' : ''} routerLink={appPage.url} routerDirection="none" lines="none" detail={false}>
                  <IonIcon aria-hidden="true" slot="start" ios={appPage.iosIcon} md={appPage.mdIcon} />
                  <IonLabel>{appPage.title}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}
        
            <IonItem button={true} lines="none" detail={false} className="w-full"
              onClick={() => OnboardingHandlers.openModal()}
            >
                <IonIcon aria-hidden="true" slot="start" ios={personOutline} md={person} />
                <IonLabel>Account</IonLabel>
            </IonItem>

            <IonItem button={true} lines="none" detail={false} className="w-full"
          
              onClick={async () => {
                const feedback = Sentry.getFeedback();
                const form = await feedback?.createForm();
                form?.appendToDom();
                form?.open();
              }}
            >
                <IonIcon aria-hidden="true" slot="start" ios={bugOutline} md={bug} />
                <IonLabel>Report a Bug</IonLabel>
            </IonItem>
        </IonList>

        <IonList id="labels-list">
          <IonListHeader>Recent Lessons</IonListHeader>
          {labels.map((label, index) => (
            <IonItem lines="none" key={index}>
              <IonIcon aria-hidden="true" slot="start" icon={bookOutline} />
              <IonLabel>{label}</IonLabel>
            </IonItem>
          ))}
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
